import { useState } from 'react';
import { t } from '../i18n.js';
import { ICOON } from './iconen.jsx';

/** Een wachtwoordveld met een oog om het te tonen, zoals in ADTS-ONE. */
export default function Wachtwoordveld({ waarde, zet, autoComplete = 'current-password' }) {
  const [zichtbaar, zetZichtbaar] = useState(false);
  const label = t(zichtbaar ? 'Wachtwoord verbergen' : 'Wachtwoord tonen');
  return (
    <span className="wwveld">
      <input type={zichtbaar ? 'text' : 'password'} value={waarde} onChange={(e) => zet(e.target.value)}
        autoComplete={autoComplete} />
      <button type="button" className="wwoog" aria-pressed={zichtbaar} aria-label={label} title={label}
        onClick={() => zetZichtbaar((v) => !v)}>{zichtbaar ? ICOON.oogDicht : ICOON.oogOpen}</button>
    </span>
  );
}
